import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { SupervisorInjuryReport } from './supervisor-injury-report.model';

export class SupervisorInjuryReportListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string = '';

  /** Type of incident */
  typeOfIncident: string = '';

  /** Employee's first name */
  employeeFirstName: string = '';

  /** Employee's last name */
  employeeLastName: string = '';

  /** Street address */
  streetAddress: string = '';

  /** Phone number */
  phone: string = '';

  id: string = '';

  constructor(data?: Partial<SupervisorInjuryReportListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new SupervisorInjuryReportListItem();
    const fieldMappings = SupervisorInjuryReport.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof SupervisorInjuryReportListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): SupervisorInjuryReportListItem {
    return new SupervisorInjuryReportListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      typeOfIncident: data.typeOfIncident,
      employeeFirstName: data.employeeFirstName,
      employeeLastName: data.employeeLastName,
      streetAddress: data.streetAddress,
      phone: data.phone
    });
  }
} 